<template>
  <el-dialog
    :visible="visible"
    @close="closeDialog"
    width="60%"
    custom-class="calendar-dialog"
  >
    <div class="title_div" slot="title">
      <i class="el-icon-arrow-left" @click="prevNext(false)"></i>
      {{ `${timeObj.year}年${timeObj.month}月` }}
      <i class="el-icon-arrow-right" @click="prevNext(true)"></i>
    </div>
    <div class="calendar_div">
      <div class="week_div">
        <span v-for="(item, index) in weekList" :key="index">{{ item }}</span>
      </div>
      <div class="date_div">
        <div
          v-for="(item, index) in dataList"
          :key="index"
          :class="classState(item.time)"
        >
          <p>{{ Number(item.time.split("-")[2]) }}</p>
          <span v-if="item.nowDayCastAcre">
            当日可投面积：{{ item.nowDayCastAcre }}亩
          </span>
          <em v-if="item.notNegotiable.isShwo">
            <i></i>
            <span> {{ item.notNegotiable.text }} </span>
            <el-tooltip
              effect="light"
              popper-class="notesttooltip"
              placement="right"
              v-if="item.notNegotiable.isShwo > 1"
            >
              <div class="tooltip_div color99" slot="content">
                <p>不可投</p>
                <ul>
                  <li v-if="item.oneDayNoCastAcre">
                    <i></i>
                    1日后不可投：{{ item.oneDayNoCastAcre }}（亩）
                  </li>
                  <li v-if="item.twoDayNoCastAcre">
                    <i></i>
                    2日后不可投：{{ item.twoDayNoCastAcre }}（亩）
                  </li>
                  <li v-if="item.threeDayNoCastAcre">
                    <i></i>
                    3日后不可投：{{ item.threeDayNoCastAcre }}（亩）
                  </li>
                </ul>
              </div>
              <img src="@/assets/images/Insurance/more.png" />
            </el-tooltip>
          </em>
          <i v-if="item.negotiable.isShwo">
            <span>{{ item.negotiable.text }}</span>
            <el-tooltip
              popper-class="testtooltip"
              placement="right"
              effect="light"
              v-if="item.negotiable.isShwo > 1"
            >
              <div class="tooltip_div color46" slot="content">
                <p>可投</p>
                <ul>
                  <li v-if="item.oneDayCastAcre">
                    <i></i>
                    1日后可投：{{ item.oneDayCastAcre }}（亩）
                  </li>
                  <li v-if="item.twoDayCastAcre">
                    <i></i>
                    2日后可投：{{ item.twoDayCastAcre }}（亩）
                  </li>
                  <li v-if="item.threeDayCastAcre">
                    <i></i>
                    3日后可投：{{ item.threeDayCastAcre }}（亩）
                  </li>
                  <li v-if="item.fourDayCastAcre">
                    <i></i>
                    4日后可投：{{ item.fourDayCastAcre }}（亩）
                  </li>
                  <li v-if="item.fiveDayCastAcre">
                    <i></i>
                    5日后可投：{{ item.fiveDayCastAcre }}（亩）
                  </li>
                </ul>
              </div>
              <img src="@/assets/images/Insurance/more.png" />
            </el-tooltip>
          </i>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { formatDate } from "@/utils";
import { insureCalendarFifteenDayList } from "@/api/request/snkd.produce";
import { SessionStorage } from "@/utils/storage";

import { mapState } from "vuex";
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      timeObj: {
        year: 0,
        month: 0,
      },
      weekList: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      dataList: [],
      allDataList: [],
      regularNum: 42,
      nowTime: formatDate(new Date(), "yyyy-MM-dd").split("-"),
      num: 0,
      dayobj: {
        list: [],
        date: [],
      },
      insureInfo: {},
    };
  },
  async created() {
    await this.dayListServr();
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },
  methods: {
    prevNext(isNext) {
      let [y, m] = this.nowTime;
      let mm = isNext
        ? Number(m) + 1 > 12
          ? 1
          : Number(m) + 1
        : Number(m) - 1
        ? Number(m) - 1
        : 12;
      let year = isNext
        ? Number(m) + 1 > 12
          ? Number(y) + 1
          : y
        : Number(m) - 1
        ? y
        : y - 1;
      this.nowTime = [year, this.coveringFun(mm), "01"];
      this.dataList = [];
      this.calendarData();
    },
    coveringFun(parems) {
      return parems >= 10 ? String(parems) : `0${parems}`;
    },
    calendarData() {
      let [y, m] = this.nowTime;
      this.timeObj.year = y;
      this.timeObj.month = m;
      this.lastMonthFun(this.nowTime);
      this.nowMonthFun(this.nowTime);
    },
    // 计算上个月几天
    lastMonthFun(params) {
      const [y, m] = params;
      const monthFirstDay = new Date(`${y}-${m}-01`);
      const monthFalstDay = monthFirstDay.getDay();
      const monthFalstTime = monthFirstDay.getTime();
      this.num = monthFalstDay ? monthFalstDay - 1 : 6;
      const list = [];
      if (!this.num) return;
      for (let i = 0; i < this.num; i++) {
        const value = new Date(
          monthFalstTime - 3600 * 1000 * 24 * (this.num - i)
        );
        list.push({
          time: formatDate(value, "yyyy-MM-dd"),
          week: value.getDay(),
          nowDayCastAcre: null,
          notNegotiable: {
            text: "",
            isShwo: 0,
          },
          negotiable: {
            text: "",
            isShwo: 0,
          },
        });
      }
      this.dataList = list;
    },
    // 计算当月及后续天
    nowMonthFun(params) {
      const [y, m] = params;
      const monthFirstTime = new Date(`${y}-${m}-01`).getTime();
      const dayobjList = this.dayobj.list;
      const dayobjDate = this.dayobj.date;
      const list = [];
      for (let i = 0; i < this.regularNum - this.num; i++) {
        const value = new Date(monthFirstTime + 3600 * 1000 * 24 * i);
        const time = formatDate(value, "yyyy-MM-dd");
        const week = value.getDay();
        const index = dayobjList.indexOf(time);
        let arry = {
          time,
          week,
          notNegotiable: {
            text: "",
            isShwo: 0,
          },
          negotiable: {
            text: "",
            isShwo: 0,
          },
        };

        if (index >= 0) {
          const item = dayobjDate[index];
          arry = { ...arry, ...item, ...this.dataFilft(item) };
        }

        list.push(arry);
      }
      this.dataList = [...this.dataList, ...list];
    },
    dataFilft(parems) {
      const date = {
        notNegotiable: {
          text: "",
          isShwo: 0,
        },
        negotiable: {
          text: "",
          isShwo: 0,
        },
      };
      const obj = {
        fiveDayCastAcre: 5,
        fourDayCastAcre: 4,
        oneDayCastAcre: 1,
        oneDayNoCastAcre: 1,
        threeDayCastAcre: 3,
        threeDayNoCastAcre: 3,
        twoDayCastAcre: 2,
        twoDayNoCastAcre: 2,
      };
      for (const key in parems) {
        if (key !== "day" && key !== "nowDayCastAcre") {
          const isNoKey = key.includes("No");
          const target = isNoKey ? date.notNegotiable : date.negotiable;
          if (parems[key]) {
            target.isShwo++;
          }
          if (!target.text && parems[key]) {
            target.text = `${obj[key]}日后${isNoKey ? "不可" : "可"}投：${
              parems[key]
            }亩`;
          }
        }
      }
      return date;
    },
    classState(params) {
      let nowData = formatDate(new Date(), "yyyy-MM-dd").split("-");
      let m = Number(params.split("-")[1]);
      let sm = this.nowTime[1];
      let className = "";
      if (m == sm) {
        if (params == `${nowData[0]}-${nowData[1]}-${nowData[2]}`) {
          className = "active";
        }
      } else {
        className = "ashmaking";
      }
      return className;
    },
    async dayListServr() {
      this.insureInfo = await SessionStorage.get("insureInfo");
      console.log("this.insureInfo", this.insureInfo);
      this.$nextTick();
      try {
        this.dayobj.date = await insureCalendarFifteenDayList({
          companyId: this.companyId,
          farmId: this.farmId,
          insureId: this.insureInfo.id,
        });
        this.dayobj.list = this.dayobj.date.map((item) => item.day);
      } catch (error) {
        console.log(error);
      } finally {
        this.calendarData();
      }
    },
    closeDialog() {
      this.$emit("closeFun");
    },
  },
};
</script>
<style lang="scss" scoped>
.title_div {
  display: flex;
  justify-content: center;
  color: #fff;
  i {
    cursor: pointer;
    margin: 0 10px;
  }
}

::v-deep .el-dialog__header {
  background-color: #64c3a4;
}

.week_div {
  display: flex;
  background-color: #f7f9fb;
  padding: 17px 0;
  span {
    width: 14.28%;
    text-align: center;
  }
}

::v-deep .el-dialog__close {
  color: #fff;
}

::v-deep .el-dialog__body {
  padding: 0;
}

.date_div {
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  > div {
    width: 14.28%;
    font-size: 10px;
    color: #fff;
    border-left: 1px solid #e8eaec;
    border-top: 1px solid #e8eaec;
    box-sizing: border-box;
    height: 127px;
    > p {
      height: 28px;
      padding: 14px 14px 0 0;
      text-align: right;
      color: #333;
      font-size: 10px;
    }
    > span {
      background-color: #4eb090;
      padding-left: 8px;
      height: 26px;
      line-height: 26px;
      display: block;
    }
    > em {
      display: flex;
      background-color: #4eb090;
      color: #ffec44;
      padding-left: 8px;
      height: 26px;
      line-height: 26px;
      align-items: center;
      > span {
        width: 110px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
      i {
        display: block;
        width: 8px;
        height: 8px;
        border-left: 1px solid #ffec44;
        border-bottom: 1px solid #ffec44;
        box-sizing: border-box;
        margin-right: 4px;
      }
      > img {
        cursor: pointer;
        width: 15px;
        margin-right: 5px;
      }
    }
    > i {
      background-color: #c3c9d1;
      padding-left: 8px;
      line-height: 26px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > span {
        width: 120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
      > img {
        cursor: pointer;
        width: 15px;
        margin-right: 5px;
      }
    }
  }
}
.active {
  background-color: #ffffcc;
}

.ashmaking {
  p {
    color: #eee !important;
  }
}

.tooltip_div {
  p {
    font-size: 14px;
    font-weight: 800;
    padding-bottom: 10px;
  }
  ul {
    li {
      line-height: 25px;
      i {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 5px;
        color: #333;
      }
    }
  }
}

.color46 {
  p {
    color: #4eb090;
  }
  i {
    background-color: #4eb090;
  }
}

.color99 {
  p {
    color: #999;
  }
  i {
    background-color: #999;
  }
}
</style>
<style lang="scss">
.testtooltip.el-tooltip__popper {
  border-color: #4eb090;
  border-radius: 10px;
}

.testtooltip.el-tooltip__popper[x-placement^="right"] .popper__arrow:after {
  border-left-color: #4eb090;
}
.testtooltip.el-tooltip__popper[x-placement^="right"] .popper__arrow {
  border-right-color: #4eb090;
}
.notesttooltip.el-tooltip__popper {
  border-color: #999;
  border-radius: 10px;
}

.notesttooltip.el-tooltip__popper[x-placement^="right"] .popper__arrow:after {
  border-left-color: #999;
}
.notesttooltip.el-tooltip__popper[x-placement^="right"] .popper__arrow {
  border-right-color: #999;
}
.calendar-dialog {
  margin-top: 4vh !important;
}
</style>
